/**
 * successHandler — single place that turns a backend success response into a
 * user message. Services call showSuccess(...) after a successful call.
 */
import { showToast } from '../components/skToast';

interface SuccessShape {
  message?: string;
  data?: { message?: string };
}

export function getSuccessMessage(response: unknown, fallback = 'Done'): string {
  const r = response as SuccessShape | undefined;
  if (r?.message && r.message.trim()) return r.message;
  if (r?.data?.message && r.data.message.trim()) return r.data.message;
  return fallback;
}

export function showSuccess(response: unknown, title: string, fallback?: string): void {
  showToast('success', title, getSuccessMessage(response, fallback));
}
